<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lista li{list-style-type: none;}
</style>

<template>
  <div>
    <b>
    <p>Agradecemos a todas las instituciones cuyas colecciones se reproducen en esta exposición y nos permiten contar la historia de uno de los episodios más notables de la historia de México, el 5 de Mayo de 1862.</p>
    <p> 
      <ul class="lista">
        <li>Biblioteca Nacional Digital de México IIB UNAM</li><br>
        <li>Centro Regional INAH Puebla</li><br>
        <li>Comisión de la Librería Estatal de Texas y Archivos</li><br>
        <li>División de imprenta y Fotografía de la Librería de Washington, D. C.</li><br>
        <li>Dorothy Sloan-Rare Books Inc.</li><br>
        <li>El Sol de México</li><br>
        <li>Fototeca Nacional</li><br>
        <li>Hacienda de Amalucan</li><br>
        <li>Instituto de Investigaciones Jurídicas UNAM</li><br>
        <li>Jorge González fotógrafo</li><br>
        <li>Mapoteca Manuel Orozco y Berra</li><br>
        <li>Mediateca INAH</li><br>
        <li>Museo Carnavalet, Historia de París</li><br>
        <li>Museo de Historia Mexicana</li><br>
        <li>Museo de la Armada, París</li><br>
        <li>Museo de la Ciudad de México</li><br>
        <li>Museo del Segundo Imperio (Francia)</li><br>
        <li>Museo Nacional de Historia Castillo de Chapultepec</li><br>
        <li>Museo Nacional de las Intervenciones</li><br>
        <li>Museo Regional “Casa de Alfeñique”</li><br>
        <li>Palacio de Versalles</li><br>
        <li>Revista “La crónica de hoy”</li><br>
        <li>Taller de Gráfica Popular</li><br>
      </ul>
    </p>
    </b>
  </div>
</template>

<script>
export default {
  name: "s31g01",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
